import Communication from '../utils/Communication';

export default class NawsCommunication extends Communication {
	/**
	 * Call to get NAWS sessions associated with the current user.
	 */
	static getSessions() {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/naws/session`,
		});
	}

	/**
	 * Call to get details associated with NAWS session.
	 * @param {Object} params - sessionId
	 */
	static getSessionDetails(params) {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/naws/session/${params.sessionId}`,
		});
	}

	/**
	 * Call to get Weight from weight scale associated with NAWS session.
	 * @param {Object} params - sessionId
	 */
	static getWeight(params) {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/r/naws/GetWeight/${params.sessionId}`,
		});
	}

	/**
	 * Call to get the status for disable Auto Weight.
	 * @param {Object} params - SDCConnectServerHost
	 */
	static getWeightStatus() {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/r/naws/GetAutoWeightStatus`,
		});
	}

	/**
	 * Call to reset scale to calibrate associated with session.
	 * @param {Object} params - sessionId
	 */
	static resetScale(params) {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/r/naws/ResetScale/${params.sessionId}`,
		});
	}

	/**
	 * Call to print to submit a print job associated with session.
	 * @param {Object} params - sessionId, printCommand, printCommandX, SDCConnectServerHost
	 */
	static print(params) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/r/naws/SubmitPrintJob/${params.sessionId}`,
			data: {
				print: params.printCommand,
				printX: params.printCommandX,
			},
		});
	}

	/**
	 * Call to refresh printers associated with session.
	 * @param {Object} params - sessionId
	 */
	static refreshPrinters(params) {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/r/naws/RefreshPrinterInfo/${params.sessionId}`,
		});
	}

	/**
	 * Call to self update associated with session.
	 * @param {Object} params - sessionId
	 */
	static selfUpdate(params) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/r/naws/SelfUpdate/${params.sessionId}`,
		});
	}
}
